import Editor from '@monaco-editor/react';
import { editor } from 'monaco-editor';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ConfigRule } from '@app/models';

function getUpdateConfigJson(config: any[]): ConfigRule[] {
  return config.map((x) => {
    return {
      id: x.id,
      name: x.name,
      description: x.description,
      properties: x.properties,
    };
  });
}

export function AddConfigEditor({
  selectedOuId,
  categoryId,
  editorContent,
  editor,
  setEditor,
}: {
  selectedOuId: string;
  categoryId: string;
  editorContent: string;
  editor: editor.IStandaloneCodeEditor;
  setEditor: Dispatch<SetStateAction<editor.IStandaloneCodeEditor>>;
}) {
  const [selectedConfigs, setSelectedConfigs] = useState<ConfigRule[]>([]);
  const onMount = async (e: editor.IStandaloneCodeEditor) => {
    setEditor(e);
  };

  const format = async () => {
    await editor?.getAction('editor.action.formatDocument').run();
  };

  useEffect(() => {
    if (editorContent) {
      setSelectedConfigs(JSON.parse(editorContent));
      return;
    }
    const newConfig: ConfigRule[] = [
      {
        name: '',
        description: '',
        properties: [],
      },
    ];
    setSelectedConfigs(newConfig);
  }, [categoryId, editorContent]);

  return (
    <>
      <div style={{ position: 'relative' }}>
        <div style={{ border: 'thin solid lightgrey' }}>
          <button
            onClick={() => format()}
            title={'Format'}
            style={{ position: 'absolute', top: '-25px', right: '0px', zIndex: 1000 }}>
            <i className={'indent icon'}></i>
          </button>
          <Editor
            height={'345px'}
            key={selectedOuId + JSON.stringify(selectedConfigs)}
            defaultLanguage={'json'}
            onMount={(e) => onMount(e)}
            defaultValue={JSON.stringify(selectedConfigs, null, 4)}
          />
        </div>
      </div>
    </>
  );
}
